<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('applyGoldWithdrawal.title') }}</span>
      </div>

      <el-form label-width="120px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('applyGoldWithdrawal.communityName')">
              <el-input 
                v-model="applyGoldWithdrawalInfo.communityName" 
                :placeholder="$t('applyGoldWithdrawal.communityNamePlaceholder')" 
                disabled
              ></el-input>
              <el-button 
                type="primary" 
                @click="openChooseGold"
                style="margin-left: 10px;"
              >
                {{ $t('applyGoldWithdrawal.choose') }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('applyGoldWithdrawal.goldName')">
              <el-input 
                v-model="applyGoldWithdrawalInfo.goldName" 
                :placeholder="$t('applyGoldWithdrawal.goldNamePlaceholder')" 
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('applyGoldWithdrawal.amount')">
              <el-input 
                v-model="applyGoldWithdrawalInfo.amount" 
                :placeholder="$t('applyGoldWithdrawal.amountPlaceholder')" 
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('applyGoldWithdrawal.applyAmount')">
              <el-input 
                v-model="applyGoldWithdrawalInfo.applyAmount" 
                :placeholder="$t('applyGoldWithdrawal.applyAmountPlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('applyGoldWithdrawal.applyUserName')">
              <el-input 
                v-model="applyGoldWithdrawalInfo.applyUserName" 
                :placeholder="$t('applyGoldWithdrawal.applyUserNamePlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('applyGoldWithdrawal.applyUserTel')">
              <el-input 
                v-model="applyGoldWithdrawalInfo.applyUserTel" 
                :placeholder="$t('applyGoldWithdrawal.applyUserTelPlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('applyGoldWithdrawal.bankNum')">
              <el-input 
                v-model="applyGoldWithdrawalInfo.bankNum" 
                :placeholder="$t('applyGoldWithdrawal.bankNumPlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('applyGoldWithdrawal.bankNumName')">
              <el-input 
                v-model="applyGoldWithdrawalInfo.bankNumName" 
                :placeholder="$t('applyGoldWithdrawal.bankNumNamePlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('applyGoldWithdrawal.bankName')">
              <el-input 
                v-model="applyGoldWithdrawalInfo.bankName" 
                type="textarea"
                :placeholder="$t('applyGoldWithdrawal.bankNamePlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('applyGoldWithdrawal.remark')">
              <el-input 
                v-model="applyGoldWithdrawalInfo.remark" 
                type="textarea"
                :placeholder="$t('applyGoldWithdrawal.remarkPlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24" style="text-align: right;">
            <el-button type="warning" @click="goBack">{{ $t('common.cancel') }}</el-button>
            <el-button type="primary" @click="saveGoldWithdrawalInfo">{{ $t('common.save') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <choose-gold ref="chooseGold"></choose-gold>
  </div>
</template>

<script>
import ChooseGold from '@/components/admin/chooseGold/ChooseGold'
import { applyGoldWithdrawal } from '@/api/admin/goldApi'

export default {
  name: 'ApplyGoldWithdrawal',
  components: {
    ChooseGold
  },
  data() {
    return {
      applyGoldWithdrawalInfo: {
        gwId: '',
        goldId: '',
        goldName: '',
        communityName: '',
        amount: '',
        applyAmount: '',
        applyUserName: '',
        applyUserTel: '',
        remark: '',
        bankNum: '',
        bankNumName: '',
        bankName: ''
      }
    }
  },
  methods: {
    openChooseGold() {
      this.$refs.chooseGold.open(this.applyGoldWithdrawalInfo)
    },
    goBack() {
      this.$router.go(-1)
    },
    async saveGoldWithdrawalInfo() {
      if (!this.validateForm()) {
        return
      }

      try {
        const res = await applyGoldWithdrawal(this.applyGoldWithdrawalInfo)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this.goBack()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    validateForm() {
      // 这里应该添加表单验证逻辑
      return true
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
.box-card {
  margin-bottom: 20px;
}
.el-input, .el-textarea {
  width: 100%;
}
</style>